module.exports = __webpack_public_path__ + "static/amamfooter-cf088aca290550891f8892678bba3281.png";